// import { deepCopy } from "@/utils/utils";
const state = {
  // wxShare: {}
}
const mutations = {
  // SET_WX_SHARE (state, value) {
  //   state.wxShare = deepCopy(value)
  // }
}
const actions = {
  // setWxShare ({ commit }, value) {
  //   commit('SET_WX_SHARE', value)
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
